import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "vexly_admin_token";

// Configure axios global interceptor — attaches the Bearer token
// from localStorage to every outgoing request and clears it on 401.
let _interceptorInstalled = false;
export function installAuthInterceptor(onUnauthorized) {
  if (_interceptorInstalled) return;
  _interceptorInstalled = true;
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem(STORAGE_KEY);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  axios.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 401) {
        localStorage.removeItem(STORAGE_KEY);
        if (typeof onUnauthorized === "function") onUnauthorized();
      }
      return Promise.reject(err);
    }
  );
}

export const auth = {
  getToken: () => localStorage.getItem(STORAGE_KEY),
  setToken: (t) => localStorage.setItem(STORAGE_KEY, t),
  clearToken: () => localStorage.removeItem(STORAGE_KEY),

  async login(email, password) {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(STORAGE_KEY, data.access_token);
    return data.user;
  },

  async me() {
    const { data } = await axios.get(`${API}/auth/me`);
    return data;
  },

  async logout() {
    try {
      await axios.post(`${API}/auth/logout`);
    } catch (_) {}
    localStorage.removeItem(STORAGE_KEY);
  },

  async listLeads(limit = 200) {
    const { data } = await axios.get(`${API}/admin/leads`, { params: { limit } });
    return data;
  },

  async stats() {
    const { data } = await axios.get(`${API}/admin/leads/stats`);
    return data;
  },

  async listUsers() {
    const { data } = await axios.get(`${API}/admin/users`);
    return data;
  },

  async createUser({ email, password, name, role }) {
    const { data } = await axios.post(`${API}/admin/users`, { email, password, name, role });
    return data;
  },

  async updateUser(userId, patch) {
    const { data } = await axios.patch(`${API}/admin/users/${userId}`, patch);
    return data;
  },

  async deleteUser(userId) {
    await axios.delete(`${API}/admin/users/${userId}`);
  },
};

// Helper: render FastAPI validation errors safely (Pydantic v2 returns
// array of objects, which would crash React if rendered directly).
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Error desconocido.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
